import React from 'react'
import { connect } from 'react-redux'
import {
  onFetchUpcomingVisits,
  onFetchSSUpcomingVisits
} from '../modules/Visits'
import VisitsPage from '../components/VisitsPage'
import { isBlockConsent } from '../../Consent/utils/consentUtils'
import Loader from 'components/D3Loader'

const mapStateToProps = (state) => {
  const { consent, visits, loading, strings, user, locales, caregiver } = state
  const { selectedLocale } = locales
  const showConsentModal = isBlockConsent(user, consent)
  // GOLD-11140: When study requires consent and we have pending consents but consent form not yet loaded,
  // keep showing loader so the blocking modal can appear once consentForm (is_blocking) is set.
  const pendingConsentsWithoutForm =
    user?.study?.consent_required &&
    (consent?.v2Consents?.length > 0) &&
    !(consent?.consentForm && Object.keys(consent.consentForm).length > 0)
  const loadingOrResolvingConsent = loading.general || pendingConsentsWithoutForm

  return {
    loading: loadingOrResolvingConsent,
    pastVisits: visits?.upcomingVisitsList?.pastVisits ?? [],
    upcomingVisits: visits?.upcomingVisitsList?.upcomingVisits ?? [],
    selectedLocale,
    showConsentModal,
    strings,
    humiIsabellaDisabled:
      user?.study?.config?.is_rewardless_study &&
      user?.study?.config?.is_avatarless_study,
    user,
    caregiver
  }
}

const mapDispatchToProps = {
  fetchUpcomingVisits: (studyId) => onFetchUpcomingVisits(studyId),
  fetchAdhocUpcomingVisits: (studyId) => onFetchSSUpcomingVisits(studyId)
}

function VisitsPageContainer(props) {
  if (props.loading) return <Loader />
  return <VisitsPage {...props} />
}

export default connect(mapStateToProps, mapDispatchToProps)(VisitsPageContainer)
